import React from 'react';
import { StyleSheet, FlatList, SafeAreaView, View } from 'react-native';

import { useTranslation } from 'react-i18next';
import BaseText from '../BaseText';
import { Color, CommonProperties } from '../../styles';
import { Screens } from '../../constants/ScreenNames';

const languages = [
  { label: 'English', code: 'en' },
  { label: 'Español', code: 'es' },
  { label: 'Deutsche', code: 'de' },
  { label: 'Français', code: 'fr' },
  { label: 'Português', code: 'pt' },
  { label: 'Italiano', code: 'it' },
];

const LanguageModal = ({ navigation }) => {
  const { i18n } = useTranslation();

  const onLanguageChangeHandler = (item) => {
    i18n.changeLanguage(item.code, () => {
      navigation.navigate(Screens.Home);
    });
  };

  const FlatListItemSeparator = () => {
    return <View style={styles.seperator} />;
  };

  return (
    <SafeAreaView style={styles.widgetContainer}>
      <FlatList
        data={languages}
        ItemSeparatorComponent={FlatListItemSeparator}
        keyExtractor={(item) => `${item.label}${item.code}`}
        renderItem={({ item }) => (
          <BaseText
            style={[styles.item, i18n.language === item.code ? styles.itemSelected : null]}
            onPress={() => onLanguageChangeHandler(item)}
          >
            {item.label}
          </BaseText>
        )}
      />
    </SafeAreaView>
  );
};

export const styles = StyleSheet.create({
  widgetContainer: {
    flexGrow: 1,
    backgroundColor: Color.accent,
  },
  item: {
    ...CommonProperties.h2,
    ...CommonProperties.p3,
  },
  itemSelected: {
    color: Color.primary,
  },
  seperator: {
    height: 1,
    width: '100%',
    backgroundColor: Color.disabled,
  },
});

export default LanguageModal;
